module.exports = __webpack_public_path__ + "media/23.a78f6423.mp3";